// extracted by mini-css-extract-plugin
module.exports = {"registerBox":"RegisterBox_registerBox__228XP"};